import React, { type PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

import { SupText as Text } from "../../../components/UI/Text";

interface SummaryProps {
  variant?: "primary-active" | "primary" | "info" | "warning" | "error" | "success";
  className?: string;
}

const VARIANTS = {
  primary: "text-neutral-50 bg-neutral-800",
  "primary-active": "text-neutral-900 bg-primary-200",
  info: "text-neutral-900 bg-info-500",
  warning: "text-neutral-50 bg-warning-600",
  success: "text-neutral-50 bg-success-600",
  error: "text-neutral-50 bg-error-700",
} as const;

export function SupTracker({ className, variant = "primary", children }: PropsWithChildren<SummaryProps>) {
  return (
    <Text as="span" variant="button" className={twMerge("sup-tracker inline-flex px-2 py-1", VARIANTS[variant], className)}>
      {children}
    </Text>
  );
}
